<template lang="pug">
  .bbct-module.xs-f-small.max-at-tweak
    transition(name="height")
      .bb-wrap(v-if="!hideAfterAdd")
        .bb-added-message.absolute-wrap.text-center.bg-gray-light(v-if="bbAdded")
          .v-center.full-width
            span.icon-check.text-color-2.xs-f-xlarge.max-at-tweak
            p.xs-f-small.max-at-tweak(role="alert") Your item was added to bag

        .bb-panel.xs-12(:class="{ 'bb-added': bbAdded }")
          .bb-intro.xs-12.text-center
            p.xs-f-medium.lg-f-xmedium.max-at-tweak {{ introText }}

          .bb-product-info.xs-12
            button.btn-reset.checkbox-wrap.full-width.text-left(@click="addBBToCart")
              .mr-checkbox(:class="{ selected: bbChecked }")
              span.ada-tooltip add to bag
              img.bb-image(:src="bbImageObj.url" alt="")

              .bb-info
                span.bb-name.upper.xs-f-xsmall.max-at-tweak {{ bbct.name }}
                span.bb-price.xs-f-small.lg-f-medium.max-at-tweak(:class="{ 'strike': promoEligible, 'bold': !promoEligible }") {{ $currency(bbct.sub_price) }}
                span.bb-price.bold.xs-f-small.lg-f-medium.max-at-tweak.xs-pl-100m(v-if="promoEligible") {{ $currency('20') }}

          .bb-ctas.xs-12
            button.btn-reset.pull-right.brand-color-1.xs-f-small.max-at-tweak(@click="showBBModal" ref="whatsThis") What's this?

</template>

<script>
  import { mapState, mapActions, mapMutations } from 'vuex';
  import { getProductById } from "@services/vueProductSvc";

  export default {
    name: "BondBuildingModule",
    inject: ['getObjProperty'],

    data() {
      return {
        bbAdded: false,
        bbct: {},
        bbChecked: false,
        loadingBbct: false,
        hideAfterAdd: false
      };
    },

    computed: {
      ...mapState('customer', ['cdata']),

      introText() {
        return `${this.getObjProperty(this.cdata, 'chemically_treated') ? 'You mentioned you have chemically-treated hair—keep your hair' : 'Help your highlighted hair stay'} strong for the next 6 weeks:`;
      },

      bbImageObj() {
        return this.getObjProperty(this.bbct, "imagery.thumb") || {};
      },

      promoEligible() {
        //- customers without any purchases
        let allTimeOrders = this.getObjProperty(this.cdata, 'totalAllTimeOrders') || 0;
        return allTimeOrders == 0;
      }
    },

    methods: {
      ...mapActions('modal', ['showModal']),
      ...mapActions('cart', ['addToCart']),
      ...mapActions('quickLook', ['showQuickLookModal']),
      ...mapMutations('pdp', ['setAttachableProdId']),
      ...mapMutations('modal', ['setReturnFocus']),

      addBBToCart() {
        if (this.bbAdded) {
          return;
        }

        this.bbChecked = true;

        let payload = {
          productId: this.bbct.id,
          ctaSource: 'Bond Building Cleanser Treatment Module'
        };

        if (this.promoEligible) {
          payload.validOffer = {
            id: 2986
          };
        }

        //- returning it for unittests
        return this.addToCart(payload).then(() => {
          this.bbAdded = true;
          this.setAttachableProdId(this.bbct.id);

          setTimeout(() => {
            this.hideAfterAdd = true;
          }, 1000);

        }).catch(() => {
          this.bbChecked = false;
          this.bbAdded = false;
        });
      },


      openQuickLook(product) {
        this.showQuickLookModal({ product });
      },

      showBBModal() {
        this.setReturnFocus(this.$refs.whatsThis);
        this.showQuickLookModal({ product: this.bbct });
        this.showModal({
          component: 'BBCTModal',
          props: { bbct: this.bbct },
          returnFocusElement: this.$refs.whatsThis,
        });
      }
    },

    created() {
      //- load bbct by id
      return getProductById({ id: 404 }).then(res => {
        this.bbct = res.data;
      });
    }

  };
</script>

<style scoped lang="stylus">
  .bbct-module
    .bb-wrap
      max-height 22em
      overflow hidden

      .bb-added-message
        margin auto
        opacity 100
        top 1em
        border-radius 0.5em

        p
          margin-top 1.5em

      .bb-panel
        opacity 100
        transition(opacity 300ms ease-in-out)
        background-color color-white
        border 1px solid ui-color-5
        border-radius 0.5em
        margin-top 1em

        &.bb-added
          opacity 0
          pointer-events none

        .bb-intro
          padding 1em 5%
          border-bottom 1px solid ui-color-5

        .bb-product-info
          padding 1.5em 5%

          .mr-checkbox
          .bb-image
          .bb-info
            display inline-block
            vertical-align top

          .mr-checkbox
            margin-top 2em

          .bb-image
            width 5.5em
            margin-right 1em

          .bb-info
            width 14em
            text-align left

            .bb-name
              display block

        .bb-ctas
          padding 1em 5%
          padding-top 0

          button
            text-decoration underline

      @media mq-mobile
        padding 0

        .bb-added-message
          width 90%

        .bb-panel
          .bb-product-info
            .bb-info
              width 11em

      @media mq-tablet
        padding 0 10%

        .bb-added-message
          width 80%

        .bb-panel
          .bb-product-info
            .bb-info
              width 9em

      @media mq-tablet-plus
        .bb-panel
          .bb-product-info
            .bb-info
              width 10em

      @media mq-desktop
        .bb-panel
          .bb-product-info
            .bb-info
              width 12em

      @media mq-desktop-plus
        .bb-panel
          .bb-product-info
            .bb-info
              width 12em

    .height-enter-active
    .height-leave-active
      transition(max-height 500ms ease-in-out)

    .height-enter
    .height-leave-to
      max-height 0

</style>
